import { render, staticRenderFns } from "./ClientProperties.vue?vue&type=template&id=f5af5044&"
import script from "./ClientProperties.vue?vue&type=script&lang=ts&"
export * from "./ClientProperties.vue?vue&type=script&lang=ts&"
import style0 from "./ClientProperties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports